'use client';

import EmptyState from '@/app/(main)/_components/empty-state/empty-state';
import { config } from '@/config/config';

export default function SearchNotFound() {
  return (
    <EmptyState
      title="Procedimento não encontrado"
      description="Não encontramos esse procedimento ou ele ainda não está disponível no site da Medprev."
      button={{
        label: 'Página inicial',
        href: config.env.baseUrl,
      }}
    />
  );
}
